export function convertMeasuresToSeconds(measures: number, bpm: number) {
  const secondPerBeat = 60 / bpm;
  const oneMeasure = secondPerBeat * 4;

  return oneMeasure * measures;
}
